import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import {
  LegacySimpleSnackBar as SimpleSnackBar,
  LegacyTextOnlySnackBar as TextOnlySnackBar,
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig,
  MatLegacySnackBarContainer as MatSnackBarContainer,
  MatLegacySnackBarRef as MatSnackBarRef,
} from '@angular/material/legacy-snack-bar';

import { SnackBarConfig } from 'v2/modules/shared/configs/snackbar.config';

/**
 * Drop-in-replacement for {@link MatSnackBar}.  Really, it's just a thin wrapper
 * around {@link MatSnackBar}, exposing the same API plus some additional things
 * to make it easier to do things we want to do regularly.
 */
@Injectable({ providedIn: 'root' })
export class LumSnackBar {
  protected simpleSnackBarComponent :typeof SimpleSnackBar;
  protected snackBarContainerComponent :typeof MatSnackBarContainer;
  protected handsetCssClass :string;

  constructor(public _snackBar :MatSnackBar) {}

  // EXPOSE MatSnackBar API
  // ==========

  open(
    message :string,
    action :string = '',
    config ?:MatSnackBarConfig,
  ) :MatSnackBarRef<TextOnlySnackBar> {
    return this._snackBar.open(message, action, {
      ...SnackBarConfig.DEFAULT,
      ...config,
    });
  }
  openFromComponent<T>(
    component :ComponentType<T>,
    config ?:MatSnackBarConfig,
  ) :MatSnackBarRef<T> {
    return this._snackBar.openFromComponent(component, {
      ...SnackBarConfig.DEFAULT,
      ...config,
    });
  }
  openFromTemplate(
    template :TemplateRef<any>,
    config ?:MatSnackBarConfig,
  ) :MatSnackBarRef<any> {
    return this._snackBar.openFromTemplate(template, {
      ...SnackBarConfig.DEFAULT,
      ...config,
    });
  }
  dismiss() :void {
    this._snackBar.dismiss();
  }

  // ADDITIONS
  // ==========

  // -- SEMANTIC
  // -----
  openError(
    message :string,
    action ?:string,
    config ?:MatSnackBarConfig,
  ) :MatSnackBarRef<TextOnlySnackBar> {
    return this.open(message, action ?? 'Dismiss', {
      ...SnackBarConfig.ERROR,
      ...config,
    });
  }
  openInfo(
    message :string,
    action ?:string,
    config ?:MatSnackBarConfig,
  ) :MatSnackBarRef<TextOnlySnackBar> {
    return this.open(message, action ?? 'Close', {
      ...SnackBarConfig.INFO,
      ...config,
    });
  }
  openSuccess(
    message :string,
    action ?:string,
    config ?:MatSnackBarConfig,
  ) :MatSnackBarRef<TextOnlySnackBar> {
    return this.open(message, action ?? 'Close', {
      ...SnackBarConfig.SUCCESS,
      ...config,
    });
  }
  openWarning(
    message :string,
    action ?:string,
    config ?:MatSnackBarConfig,
  ) :MatSnackBarRef<TextOnlySnackBar> {
    return this.open(message, action ?? 'Dismiss', {
      ...SnackBarConfig.WARNING,
      ...config,
    });
  }
}
